import * as angular from 'angular';
import {apsCommon} from "../../shared/dto/aps.common";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import CountsServiceName, {CountsService} from "../../services/counts/counts.service";
import template from './inconsistentEquipmentConfigurations.tpl.html';

let requires = [LoaderServiceName, CountsServiceName];

export interface InconsistentEquipmentConfigurationsController {
  inconsistencies: apsCommon.InconsistentEquipmentConfigurationItem[];
  close(): void;
}

export interface InconsistentEquipmentConfigurationsData {
  shopId: string;
  equipmentId: string;
  lineConfig: apsViewModels.ShopInspectionLines;
  equipmentName: string;
}

export function openInconsistentConfigurations(data: InconsistentEquipmentConfigurationsData,
                                               $modal: mm.foundation.modal): angular.IPromise<any> {
  return $modal.open({
    template: template,
    controller: 'InconsistentEquipmentConfigurationsCtrl as vm',
    resolve: {
      data: () => data
    }
  }).result;
}

class InconsistentEquipmentConfigurationsControllerImpl implements InconsistentEquipmentConfigurationsController {
  private $modalInstance: mm.foundation.modalInstance;
  private loaderService: LoaderService;
  private countsService: CountsService;
  equipmentId: string;
  shopId: string;
  equipmentName: string;
  lineConfig: apsViewModels.ShopInspectionLines;
  inconsistencies: apsCommon.InconsistentEquipmentConfigurationItem[];

  constructor(data: InconsistentEquipmentConfigurationsData,
              $modalInstance: mm.foundation.modalInstance,
              loaderService: LoaderService,
              countsService: CountsService) {

    this.$modalInstance = $modalInstance;
    this.loaderService = loaderService;
    this.countsService = countsService;
    this.equipmentName = data.equipmentName;

    let dataPromise = this.countsService.getEquipmentInconsistencies(data.shopId, data.equipmentId, data.lineConfig)
      .then(inconsistenciesResult => {
        this.inconsistencies = inconsistenciesResult;
      });

    this.loaderService.loadingPromise(dataPromise);
  }

  close(): void {
    this.$modalInstance.close();
  }
}

export default angular.module('aps.controller.counts.inconsistentEquipmentConfigurations', requires)
  .controller('InconsistentEquipmentConfigurationsCtrl', InconsistentEquipmentConfigurationsControllerImpl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/counts/inconsistentEquipmentConfigurations.controller.ts